export class CargoInfo {
  weight?: number;
  cargoTypes: string[] = [];
  comment?: string;
}
